import { getLocale } from "../runtime";

const sv_iconview = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Visa`
};

const iconview = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconview(inputs)
	return "iconView";
};

export { iconview as "iconView" };